import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchProjectData } from '../utils/api';

const AlbumContext = createContext();

export const AlbumProvider = ({ children }) => {
  const [currentAlbum, setCurrentAlbum] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const projectId = localStorage.getItem('albumGeneratorUser');

  const fetchData = async () => {
    const currentProjectId = localStorage.getItem('albumGeneratorUser');
    if (!currentProjectId) {
      setCurrentAlbum(null);
      setHistory([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await fetchProjectData();
      setCurrentAlbum(data.currentAlbum);
      setHistory(data.history);
      return { success: true }; // Add this to help Settings page
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  // Initial data fetch only if we have a project ID
  useEffect(() => {
    if (projectId) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [projectId]); // Run when projectId changes

  return (
    <AlbumContext.Provider value={{
      currentAlbum,
      history,
      loading,
      error,
      refreshData: fetchData,
      hasProject: !!projectId
    }}>
      {children}
    </AlbumContext.Provider>
  );
};

export const useAlbum = () => {
  const context = useContext(AlbumContext);
  if (!context) {
    throw new Error('useAlbum must be used within an AlbumProvider');
  }
  return context;
};